import React, { Component } from 'react';
import { Container, Row, Col, Card, CardContent, Button, Translate } from '$common';
import { Link } from 'react-router';
import CSSModules from 'react-css-modules';
import style from './layout.scss';
import { FadeIn } from 'animate-components';
import { browserHistory } from 'react-router';



@CSSModules(style, { allowMultiple: true })
export default class Layout extends Component {
  render() {
    const { title, children, type, valueProposition } = this.props;

    return (
      <div className="full-height" styleName={`root`}>
        <Link to="https://www.twentify.com/">
          <img src={require('$shared/images/logo_inverted.svg')} alt="" styleName="logo"/>
        </Link>
        <div styleName="panel left">
          <div styleName="inner">
            {valueProposition}
          </div>
        </div>
        <div styleName="panel right">
          <div styleName="inner">
            <FadeIn duration=".5s" key={1}>
              <h1>{title}</h1>
              {children}
              <div styleName="cta">
                {
                  type === 'login' ? 
                    [
                      <img src={require('$shared/images/rocket.svg')} alt="" key={0}/>,
                      <div styleName="text" key={1}>{Translate.get('dont_have_an_account')}</div>,
                      <Button type="grey-ghost" styleName="button" size="micro" key={2} onClick={() => browserHistory.push('/signup')}>{Translate.get('sign_up')}</Button>
                    ]
                  : ''
                }
                {
                  type === 'signup' ? 
                    [
                      <div styleName="text" key={0}>{Translate.get('already_have_an_account')}</div>,
                      <Button type="grey-ghost" styleName="button" size="micro" key={1} onClick={() => browserHistory.push('/login')}>{Translate.get('sign_in')}</Button>
                    ]
                  : ''
                }
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/layout.js